module.exports = __webpack_public_path__ + "img/circles.1181204b.svg";